import { cn } from "@repo/utils";
import { Circle } from "lucide-react";

export default function ProjetFormationDennosPJ() {
  const date = new Date();

  return (
    <>
      <div className={cn("self-center")}>
        <img src="/logos/demos.png" alt="logo_demos" width={300} height={300} />
      </div>
      <div className={cn("self-center text-center text-3xl font-bold")}>
        Formation : RSE et Développement Durable
      </div>
      <div className={cn("text-center text-3xl")}>
        Devenir une entreprise Responsable
      </div>
      <div className={cn("space-y-4")}>
        <div className={cn("")}>
          {`Les entreprises responsables s'engagent aujourd'hui à contribuer aux
          objectifs du `}
          <span>développement durable</span>
          {` parce qu'elles
          assument leur `}
          <span>responsabilité environnementale et sociale</span>. A la
          recherche unique du profit, elles préfèrent la voie de la croissance{" "}
          <span>responsable</span> qui induit la réduction des impacts
          environnementaux et sociétaux, liés à leurs activités, et au-delà une
          recherche de création de valeur pour ses parties prenantes (clients,
          fournisseurs, collectivité, collaborateurs, médias, banques et
          assurances, entités réglementaires etc .. ).{" "}
        </div>
        <div>
          {`En ${date.getFullYear()}, il ne s'agit plus de se demander s'il faut changer mais
          comment il faut changer.`}
        </div>
        <div>
          Notre offre RSE est conçue pour aider les entreprises à agir de
          manière raisonnée, à choisir ses enjeux prioritaires en matière de
          développement durable, à faire évoluer les métiers clés dans leurs
          pratiques ...{" "}
        </div>
        <div>{`Mettre en œuvre la démarche RSE dans l'entreprise`}</div>
        <ul className={cn("list-disc pl-12")}>
          <li>
            Savoir exprimer ses engagements vis-à-vis des parties prenantes.
          </li>
          <li>
            {`Connaître les différents outils de diagnostic interne et externe RSE
            : autodiagnostic pour évaluer les pratiques actuelles, réaliser un
            bilan carbone et/ou un bilan énergétique, faire un bilan
            réglementaire, réaliser un benchmarking, s'appuyer sur l'ISO 26000
            etc.`}
          </li>
          <li> Identifier et hiérarchiser ses enjeux RSE.</li>
          <li>
            {`Définir une politique RSE, ancrer le projet dans la stratégie et les
            valeurs de l'entreprise.`}
          </li>
          <li>Se fixer des objectifs mesurables.</li>
          <li>{`Formaliser et suivre le plan d'actions.`}</li>
          <li>Le tableau de bord RSE : choisir les bons indicateurs.</li>
        </ul>

        <ul className={cn("pl-24")}>
          <li className={cn("flex space-x-4")}>
            <Circle className={cn("w-2")} />
            <div>Durée: 5 jours (35 heures)</div>
          </li>
          <li className={cn("flex space-x-4")}>
            <Circle className={cn("w-2")} />
            <div>Prix : 7 600€ T.T.C. pour un groupe de 8 à 12 personnes</div>
          </li>
        </ul>
      </div>
    </>
  );
}

ProjetFormationDennosPJ.title = `Projet Formation`;
